define("shared/components/shared/suggestion-text-area", ["exports", "@ember/component", "@ember/object", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div id={{@componentId}}>
    <label class="tMM--panel__title--md u--m__t__0" for={{@textAreaId}}>
      {{@labelText}}
    </label>
    <div class={{@textareWrapperClass}}>
      <Textarea
        @value={{@value}}
        class="tMM--form__textarea"
        data-test-id="suggestion-text-area-value"
        id={{@textAreaId}}
        {{autoresize}}
        ...attributes
      />
      <div class="tMM--form__textPresetGroup">
        {{#each @suggestedValues as |suggestedValue index|}}
          <Shared::Ui::Button
            @additional="rounded"
            @class="tMM--form__textPresetBtn"
            @onClick={{fn this.appendSuggestedValue suggestedValue}}
            @text={{suggestedValue}}
            @variant="unstyled"
            data-test-id={{concat "suggestion-text-area-suggestion-value-" index}}
            type="button"
          />
        {{/each}}
      </div>
    </div>
  </div>
  */
  {
    "id": "QvdqCYuq",
    "block": "[[[10,0],[15,1,[30,1]],[12],[1,\"\\n  \"],[10,\"label\"],[14,0,\"tMM--panel__title--md u--m__t__0\"],[15,\"for\",[30,2]],[12],[1,\"\\n    \"],[1,[30,3]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[15,0,[30,4]],[12],[1,\"\\n    \"],[8,[39,0],[[24,0,\"tMM--form__textarea\"],[24,\"data-test-id\",\"suggestion-text-area-value\"],[16,1,[30,2]],[17,5],[4,[38,1],null,null]],[[\"@value\"],[[30,6]]],null],[1,\"    \"],[10,0],[14,0,\"tMM--form__textPresetGroup\"],[12],[1,\"\\n\"],[42,[28,[37,3],[[28,[37,3],[[30,7]],null]],null],null,[[[1,\"        \"],[8,[39,4],[[16,\"data-test-id\",[28,[37,5],[\"suggestion-text-area-suggestion-value-\",[30,9]],null]],[24,4,\"button\"]],[[\"@additional\",\"@class\",\"@onClick\",\"@text\",\"@variant\"],[\"rounded\",\"tMM--form__textPresetBtn\",[28,[37,6],[[30,0,[\"appendSuggestedValue\"]],[30,8]],null],[30,8],\"unstyled\"]],null],[1,\"\\n\"]],[8,9]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@componentId\",\"@textAreaId\",\"@labelText\",\"@textareWrapperClass\",\"&attrs\",\"@value\",\"@suggestedValues\",\"suggestedValue\",\"index\"],false,[\"textarea\",\"autoresize\",\"each\",\"-track-array\",\"shared/ui/button\",\"concat\",\"fn\"]]",
    "moduleName": "shared/components/shared/suggestion-text-area.hbs",
    "isStrictMode": false
  });
  let SuggestionTextAreaComponent = _exports.default = (_class = class SuggestionTextAreaComponent extends _component2.default {
    appendSuggestedValue(suggestedValue, event) {
      event.preventDefault();
      const textArea = document.getElementById(this.args.textAreaId);
      if (!textArea) {
        return;
      }
      const newValue = textArea.value.length ? ` ${suggestedValue}` : suggestedValue;
      textArea.value += newValue;
      textArea.dispatchEvent(new Event('change'));
    }
  }, (_applyDecoratedDescriptor(_class.prototype, "appendSuggestedValue", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "appendSuggestedValue"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SuggestionTextAreaComponent);
});